import { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { LayoutPage } from "../pages/LayoutPage";
import { FormSubmittedPage } from "../pages/FormSubmittedPage/FormSubmittedPage";
import { HomePage } from "../pages/HomePage/HomePage";
import { AboutPage } from "../pages/AboutPage/AboutPage";
import { PrivacyPolicyPage } from "../pages/PrivacyPolicyPage/PrivacyPolicyPage";
import { CookiePolicyPage } from "../pages/CookiePolicyPage/CookiePolicyPage";
import { translations } from "../shared/translations";

function App() {
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem("language");

    return savedLanguage && translations[savedLanguage] ? savedLanguage : "ua";
  });
  const [cookieConsent, setCookieConsent] = useState(() => {
    return localStorage.getItem("cookieConsent");
  });
  const [isCookieBannerOpen, setIsCookieBannerOpen] = useState(() => {
    return !localStorage.getItem("cookieConsent");
  });

  useEffect(() => {
    localStorage.setItem("language", language);
  }, [language]);

  useEffect(() => {
    if (!cookieConsent) {
      return;
    }

    localStorage.setItem("cookieConsent", cookieConsent);
  }, [cookieConsent]);

  const t = translations[language];

  const handleCookieConsentChange = (value) => {
    setCookieConsent(value);
    setIsCookieBannerOpen(false);
  };

  const handleOpenCookieSettings = () => {
    setIsCookieBannerOpen(true);
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          <LayoutPage
            cookieConsent={cookieConsent}
            isCookieBannerOpen={isCookieBannerOpen}
            language={language}
            onCookieConsentChange={handleCookieConsentChange}
            onOpenCookieSettings={handleOpenCookieSettings}
            onLanguageChange={setLanguage}
            t={t}
          />
        }
      >
        <Route index element={<HomePage t={t} />} />
        <Route
          path="about-us"
          element={
            <AboutPage
              cookieConsent={cookieConsent}
              onOpenCookieSettings={handleOpenCookieSettings}
              t={t}
            />
          }
        />
        <Route path="privacy-policy" element={<PrivacyPolicyPage t={t} />} />
        <Route path="cookie-policy" element={<CookiePolicyPage t={t} />} />
        <Route path="form_submitted" element={<FormSubmittedPage t={t} />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
